import { Paper } from "@mui/material";
import { useStore } from "@tanstack/react-form";

import { withForm } from "components/Forms/AppForm";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { ppFilterDefaultValues } from "../../../context/ppFilterDefaultValues";
import { useFilteredPps } from "../../../hooks/useFilteredPps";

import { ppColumns } from "./PpColumns";
import { PpToolbar } from "./PpToolbar";

const PPTableView = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const filters = useStore(form.store, (state) => state.values);
    const { protectionProfiles, isLoading } = useFilteredPps(filters);

    const status = filters.archived ? "Archived" : "Approved";

    return (
      <Paper
        elevation={1}
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
          margin: 0,
          marginTop: "1em",
          padding: 0,
          height: "100%",
        }}
      >
        <DefaultDataGrid
          loading={isLoading}
          rows={protectionProfiles}
          columns={ppColumns}
          getRowId={(row) => row.pp_id}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          columnVisibilityModel={{
            pp_transition: !filters.archived,
          }}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 50, page: 0 },
            },
          }}
          slots={{ toolbar: () => <PpToolbar status={status} /> }}
          getEstimatedRowHeight={() => 48}
          sx={{
            ".MuiDataGrid-cell": {
              padding: "1em",
              borderTop: "none",
            },
            ".MuiDataGrid-row": {
              alignItems: "center",
              borderTop: "1px solid var(--rowBorderColor)",
            },
            flex: 1,
          }}
          autoHeight={true}
        />
      </Paper>
    );
  },
});

export default PPTableView;
